"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertNonNullish = void 0;
function assertNonNullish(value, message) {
    if (value === null || value === undefined) {
        throw Error(message);
    }
}
exports.assertNonNullish = assertNonNullish;
//# sourceMappingURL=assert.js.map